import { timelineCases } from "@/mocks/home";

export default function ArchiveTimeline() {
  return (
    <section id="archive" className="w-full bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          {/* intro */}
          <div className="lg:col-span-4">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">独家档案</p>
            <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              一份声明被删之前，
              <br />
              我们把事情重新走了一遍
            </h2>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">
              从一句流传的评论，到最终一份「独家档案」。我们用可查证的时间线，把未公开细节逐阶段归档，还原事件真实的推进节奏。
            </p>
            <a
              href="#resource"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 font-label text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看全部档案
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>

          {/* timeline */}
          <ol className="relative lg:col-span-8">
            <span className="absolute bottom-2 left-[15px] top-2 w-px bg-background-300 lg:left-[19px]" aria-hidden="true" />
            {timelineCases.map((c) => (
              <li key={c.phase} className="relative pl-12 lg:pl-16">
                <span className="absolute left-0 top-1 flex h-8 w-8 items-center justify-center rounded-full border-2 border-background-300 bg-background-50 lg:h-10 lg:w-10">
                  <i className="ri-focus-2-line text-accent-600" />
                </span>
                <div className="pb-7 lg:pb-8">
                  <div className="flex flex-wrap items-center gap-2.5">
                    <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-[11px] font-semibold text-accent-900">
                      {c.phase}
                    </span>
                    <span className="font-label text-xs text-foreground-400">{c.date}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">{c.title}</h3>
                  <p className="mt-1.5 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">{c.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}